const MAGICBUY_PROJECTS = ['mgb-pc', 'mgb-h5']
const PC_PROJECTS = ['pc', 'mgb-pc']
const H5_PROJECTS = ['h5', 'mgb-h5']
const H5_TEST_PACKAGE_PROJECTS = {
  h5: 'kkren-h5',
  'mgb-h5': 'mgb-h5',
}

export function isMagicbuyProject (project) {
  return MAGICBUY_PROJECTS.includes(project)
}

// 是否为 H5 端（巧巧郎 h5 / 买即可 mgb-h5），用于共享组件区分 PC 新分页与 H5 App 内跳转
export function isH5Project (project) {
  return H5_PROJECTS.includes(project)
}

export function getWebVersionHeaderName (project) {
  if (PC_PROJECTS.includes(project)) {
    return 'Pc-Ver'
  }
  if (H5_PROJECTS.includes(project)) {
    return 'H5-Ver'
  }
  return ''
}

export function shouldRestrictBatchTrackingNosToParentChild (project, edition) {
  return edition !== 's' && !isMagicbuyProject(project)
}

export function getProjectBrandName (project) {
  return isMagicbuyProject(project) ? '買即可' : '巧巧郎'
}

export function getH5TestPackageProject (project) {
  const testPackageProject = H5_TEST_PACKAGE_PROJECTS[project]
  if (!testPackageProject) {
    throw new Error(`不支持下载测试包的 H5 项目：${project}`)
  }
  return testPackageProject
}

export function canShowJybCoinFeatures (project) {
  return !isMagicbuyProject(project)
}

export function isJybCoinCoupon (coupon = {}) {
  const source = String(coupon.crSource || coupon.coinSource || coupon.source || '').toUpperCase()
  if (source === 'PCL') {
    return true
  }

  const text = [
    coupon.cpnCode,
    coupon.crCpnCode,
    coupon.cpnName,
    coupon.crSource,
    coupon.coinSource,
  ].filter(Boolean).join(' ').toLowerCase()

  return text.includes('jypointsub') ||
    text.includes('金巧幣') ||
    text.includes('金巧币')
}

export function filterJybCoinCoupons (coupons = [], project) {
  if (canShowJybCoinFeatures(project)) {
    return coupons
  }
  return coupons.filter(coupon => !isJybCoinCoupon(coupon))
}
